import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

export const mapItems = (data) => {
  return {...data, id: data.id, uuidOrFriendlyName: data.uuid + ' - ' + data.friendlyName};
};

class GatewaySelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Gateway',
      label: 'friendlyName',
      value: 'id',
      mapItems,
      url: 'cloud/v1/gateways/' +'?size=5000'
    };
  }
}

GatewaySelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default GatewaySelector;



// WEBPACK FOOTER //
// ./src/gateways/component/GatewaySelector.js